import React, { useContext, useEffect, useMemo } from 'react'
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { AuthContext } from '../../App'
import { canAccessBlog } from '../../config/blogAccessControl'
import TabNav from '../../ui/TabNav/TabNav'
import Button from '../../ui/Button/Button'
import BlogMaterialsList from './BlogMaterialsList'
import BlogMaterialEditor from './BlogMaterialEditor'
import BlogTagsManager from './BlogTagsManager'
import styles from './Blog.module.scss'

const TAB_LINKS = [
  { title: 'Матеріали', path: '/blog/materials' },
  { title: 'Категорії та теги', path: '/blog/tags' },
]

function BlogShell({ children, actionButton = null }) {
  return (
    <>
      <TabNav links={TAB_LINKS} buttons={actionButton} />
      <div className={`Blog ${styles.content}`.trim()}>{children}</div>
    </>
  )
}

function Blog() {
  const { setPageTitle, user } = useContext(AuthContext)
  const history = useHistory()
  const location = useLocation()
  const allowed = canAccessBlog(user)
  const isEditor =
    location.pathname.startsWith('/blog/materials/') &&
    location.pathname !== '/blog/materials/'

  useEffect(() => {
    setPageTitle('Блог')
  }, [setPageTitle])

  const actionButton = useMemo(() => {
    if (location.pathname.startsWith('/blog/tags')) {
      return (
        <Button
          theme="circle"
          fill="accent"
          icon="plus"
          tooltip="Додати категорію або тег"
          onClick={() => {
            window.dispatchEvent(new CustomEvent('blog:new-tag'))
          }}
        />
      )
    }
    if (
      location.pathname === '/blog/materials' ||
      location.pathname === '/blog' ||
      isEditor
    ) {
      return (
        <Button
          theme="circle"
          fill="accent"
          icon="plus"
          tooltip="Додати матеріал"
          onClick={() => history.push('/blog/materials/new')}
        />
      )
    }
    return null
  }, [location.pathname, history, isEditor])

  if (!allowed) {
    return <Redirect to="/marketing/promos" />
  }

  return (
    <BlogShell actionButton={actionButton}>
      <Switch>
        <Route exact path="/blog" render={() => <Redirect to="/blog/materials" />} />
        <Route exact path="/blog/materials" component={BlogMaterialsList} />
        <Route exact path="/blog/materials/new" component={BlogMaterialEditor} />
        <Route exact path="/blog/materials/:id" component={BlogMaterialEditor} />
        <Route exact path="/blog/tags" component={BlogTagsManager} />
        <Redirect to="/blog/materials" />
      </Switch>
    </BlogShell>
  )
}

export default Blog
